const form = document.getElementById("custom-recharge-form");
const quantityInput = document.getElementById("recharge-quantity");
const quantityElement = document.getElementById("custom-recharge-form-quantity");
const summaryElement = document.getElementById("custom-recharge-form-summary");
const priceElement = document.getElementById("custom-recharge-form-price");
const save_text = document.getElementById("custom-recharge-form-saving")

let config = { childList: true };
let radioContainer = document.getElementById("custom-recharge-form-radios");
let checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');

let quantity;

const linkedProductsSelect = document.getElementById('linked-product-select');

if(quantityInput){
    quantity = parseInt(quantityInput.value);

    let targetNode = document.getElementsByClassName("recharge-subscription-widget")[0].getElementsByTagName("DIV")[0];

    let observer = new MutationObserver(function (mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === "childList") {
                let select = targetNode.querySelector('select[name="rc_selling_plan"]');
                if (select) {
                    let options = select.options;
                    radioContainer.innerHTML = "";
    
                    for (let i = 0; i < options.length; i++) { // Création des radio butons en fonction du select Recharge
                        let option = options[i];
    
                        let divWrapper = document.createElement("div");
                        divWrapper.className = "custom-recharge-form-radio"
    
                        let radio = document.createElement("input");
                        radio.type = "radio";
                        radio.name = "selling_plan";
                        radio.value = option.value;
                        radio.setAttribute("form", productFormId);
                        radio.id = "recharge-frequency-" + i;
                        if (i === options.length - 1)
                            radio.checked = true;
                        
                        let label = document.createElement("label");
                        label.innerHTML = option.text + ((i === options.length - 1)? ' (Standard)' : ' (Extra contrôle des odeurs)');
                        label.setAttribute("for", "recharge-frequency-" + i);
    
    
                        divWrapper.appendChild(radio);
                        divWrapper.appendChild(label);
                        radioContainer.appendChild(divWrapper);
                    }
    
                    observer.disconnect();
                }
            }
        }
    });

    observer.observe(targetNode, config);

} else if(linkedProductsSelect){
    quantity = parseInt(linkedProductsSelect.options[linkedProductsSelect.selectedIndex].dataset.nb);
}

// Fonction pour mettre à jour les détails en fonction des inputs
function updateFormDetails() {
    const frequencyInputs = document.querySelectorAll('div[class="custom-recharge-form-radio"]');
    let frequency = "";

    if(quantityInput){
        quantity = parseInt(quantityInput.value);
    } else if(linkedProductsSelect){
        quantity = parseInt(linkedProductsSelect.options[linkedProductsSelect.selectedIndex].dataset.nb);
    }

    frequencyInputs.forEach((input) => {
        radio = input.querySelector('input')
        label = input.querySelector('label')
        if (radio.checked)
            frequency = label.textContent.replace('Livraison', 'livrés');
    });

    if (quantity > 1) {
        save_text.style.display = "block";
        var real_price = Number(quantity) * 22;
        var retail_price = Number(quantity) * 24;
        real_price = real_price.toFixed(2).replace(".", ",");
        retail_price = retail_price.toFixed(2).replace(".", ",");
        priceElement.innerHTML = `<span class="compare-price">€${retail_price}</span> €${real_price}`
    }
    else {
        save_text.style.display = "none";
        priceElement.innerHTML = `24,00 per zak`
    }

    frequency = frequency.replace("Levering elke", "").trim();
    const quantityText = `${quantity} zakken Pacha`;
    const summaryText = `${quantity} zakken Pacha worden elke ${frequency} geleverd`;

    quantityElement.textContent = quantityText;
    summaryElement.textContent = summaryText;
}

form.addEventListener("change", updateFormDetails);

// Fonction pour mettre à jour le select Recharge en fonction du radio custom checked
function updateSelectFromRadio() {
    if(targetNode){
      let select = targetNode.querySelector('select[name="rc_selling_plan"]');
    }
    checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');

    if (checkedRadio) {
        select.value = checkedRadio.value;
        let changeEvent = new Event('change', {
            bubbles: true,
            cancelable: true
        });
        // Déclenche l'événement "change" sur le select pour changer l'url avec le selling_plan (comportement normal de Recharge)
        select.dispatchEvent(changeEvent);
    }
}

if(quantityInput){
  radioContainer.addEventListener("change", updateSelectFromRadio);
}

let checkoutButton = document.querySelector('[checkout-button]');

if(checkoutButton) {
    checkoutButton.addEventListener('click', goCheckout);
}

function goCheckout(redirect = true) {
    checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');

    if (checkedRadio) {

        const quantityToSubmit = linkedProductsSelect ? 1 : quantity;

        let formData = {
            'items': [{
                id: productId,
                quantity: quantityToSubmit,
                selling_plan: parseInt(checkedRadio.value)
            }]
        };

        return fetch(`/cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then(data => {
            // Cadeau du funnel (gratis mat… via pages offre) : ré-ajout depuis bonus_variant (URL)
            // ou plfb_bonus_variant (sessionStorage), comme le fix FR. Ne s'ajoute que si un bonus
            // est en attente. Le checkout NL passe par Juo : on lui renvoie EXPLICITEMENT sac + cadeau
            // (pas le panier complet, pour ne pas réinjecter d'éventuels articles accumulés).
            // IMPORTANT : la clé sessionStorage n'est PAS supprimée — Juo appelle goCheckout(false)
            // à chaque passage au checkout (étape non finale), donc le cadeau doit persister si
            // l'utilisateur revient en arrière et re-sélectionne une autre offre.
            var bonusId = null, pachaFreebie = null, bonusItems = [];
            try {
                var qs = new URLSearchParams(window.location.search);
                bonusId = qs.get('bonus_variant') ||
                    (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('plfb_bonus_variant') : null);
                // XL-mat : offre retiree le 30/07/2026 (cadeau autorise FR et UK uniquement).
                if (bonusId && parseInt(bonusId, 10) === 55568612000120) bonusId = null;
                try {
                    var raw = (typeof sessionStorage !== 'undefined') ? sessionStorage.getItem('pacha_freebie') : null;
                    if (raw) pachaFreebie = JSON.parse(raw);
                } catch (e) { pachaFreebie = null; }
                if (bonusId) bonusItems.push({ id: parseInt(bonusId, 10), quantity: 1 });
                if (pachaFreebie && pachaFreebie.variant_id) {
                    bonusItems.push({ id: parseInt(pachaFreebie.variant_id, 10), quantity: 1, properties: pachaFreebie.properties || {} });
                }
            } catch (e) { bonusItems = []; }

            if (!bonusItems.length) {
                if (redirect) { window.location.href = '/checkout'; return; }
                return data;
            }

            return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: bonusItems })
            })
            .then(function (r) { return r.json(); })
            .then(function (bonusData) {
                if (redirect) { window.location.href = '/checkout'; return; }
                // redirect=false : appelé par Juo. Renvoie sac + cadeau explicitement -> Juo
                // réinjecte exactement ces lignes après son cart/clear (pas d'accumulation).
                var mainItems = (data && data.items) ? data.items : [];
                var addedBonus = (bonusData && bonusData.items) ? bonusData.items : [];
                return Object.assign({}, data, { items: mainItems.concat(addedBonus) });
            })
            .catch(function () {
                if (redirect) { window.location.href = '/checkout'; return; }
                return data;
            });
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
}

window.checkoutFunctions = window.checkoutFunctions ? {
    ...window.checkoutFunctions,
    productPageCheckoutFn: goCheckout,
} : {
    productPageCheckoutFn: goCheckout,
};

class ProductSelector extends HTMLElement{
    constructor(){
        super();

        this.select = this.querySelector('select');
    }

    connectedCallback(){
        this.setProductId();

        this.select.addEventListener('change', () => {
            this.setProductId();

            const activeOption = this.select.options[this.select.selectedIndex];
            this.setActiveFormRadios(activeOption.dataset.index);
        })

    }

    setProductId(){
        productId = parseInt(this.select.value);
    }

    setActiveFormRadios(index){
        const allRadios = document.querySelectorAll('.custom-recharge-form-radios')

        allRadios.forEach(radio => {
            if(radio.dataset.index === index){
                radio.classList.remove('hidden');

                const radioInputs =  radio.querySelectorAll('input');

                radioInputs[1].checked = true;
            }
            else{
                radio.classList.add('hidden');
            }
        })
    }
}

customElements.define('product-selector', ProductSelector);